import schema from '../schemas/_optionCategories';

const optionCategoriesReducer = (state = schema, action) => {
  switch (action.type) {
    case 'SET_OPTION_CATEGORIES':
      return [...action.data];

    default:
      return [...state];
  }
};

export default optionCategoriesReducer;
